import React from 'react';

import { Add as AddIcon } from '@mui/icons-material';

import { Button, DetailPageLayout } from 'src/components/common';
import { PeosDetailsEmployers } from 'src/components/peo/PeosDetailsEmployers';
import { ModalId } from 'src/constants/modals';
import { usePeoParamId } from 'src/hooks/peo';
import { useModal } from 'src/hooks/shared';
import { useCurrentUserPermissions } from 'src/hooks/user';
import {
  InviteEmployersUnderPeoModal,
  InviteEmployersUnderPeoModalArgs,
} from 'src/modals/employer';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoDetailEmployersPage: React.FC = () => {
  const peoId = usePeoParamId();
  const { openModal } = useModal();
  const { isPeoPayrollProviderUser } = useCurrentUserPermissions();

  const handleInviteModalOpen = React.useCallback(() => {
    const args: InviteEmployersUnderPeoModalArgs = { peoId };
    openModal(ModalId.InviteEmployersUnderPeo, args);
  }, [openModal, peoId]);

  return (
    <DetailPageLayout
      titleContent={isPeoPayrollProviderUser ? 'Employers under PEO' : 'Employers'}
      topRightContent={
        <Button
          variant="contained"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleInviteModalOpen}
        >
          New
        </Button>
      }
    >
      <TableDataProvider>
        <PeosDetailsEmployers peoId={peoId} />

        {/* Must be inside the provider */}
        <InviteEmployersUnderPeoModal />
      </TableDataProvider>
    </DetailPageLayout>
  );
};
